import { Roles } from 'user/UserConstants';
import BoxBody from 'components/BoxBody.jsx';
import CopySubscriberButton from 'groups/components/CopySubscriberButton.jsx';
import CurrentUser from 'auth/CurrentUser';
import FeatureStore from 'stores/FeatureStore';
import Fieldset from 'components/Fieldset.jsx';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupMembership from 'entities/GroupMembership';
import GroupStore from 'groups/stores/GroupStore';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import React from 'react';
import Relationship from 'entities/Relationship';
import RelationshipViewGroupList from 'user/components/RelationshipViewGroupList.jsx';
import RelationshipViewHeader from 'user/components/RelationshipViewHeader.jsx';
import RelationshipViewProfileHeader from 'user/components/RelationshipViewProfileHeader.jsx';
import RelationshipViewMediums from 'user/components/RelationshipViewMediums.jsx';
import RelationshipViewNotes from 'user/components/RelationshipViewNotes.jsx';
import RelationshipViewUntrustedName from 'user/components/RelationshipViewUntrustedName.jsx';
import Subscriber from 'entities/Subscriber';
import Subscriptions from 'collections/Subscriptions';
import TeacherDetail from 'admin/entities/TeacherDetail';
import TeacherDetailActivitySection from 'admin/components/TeacherDetailActivitySection.jsx';

import cx from 'classnames';

import './styles/RelationshipView.scss';
import 'styles/utilities.scss';

const wrapSubscriptions = (subscriptions) => subscriptions.map(subscription =>
  ({ group: subscription.getGroup(), subscription }));

const wrapGroups = (groups, subscriptions) => groups.map(group =>
  ({ group, subscription: subscriptions.find(sub => group.id === sub.getGroupId()) }));

const RelationshipView = React.createClass({
  propTypes: {
    groupToAdmin: React.PropTypes.instanceOf(Group),
    groupMember: React.PropTypes.instanceOf(GroupMembership),
    relationship: React.PropTypes.instanceOf(Relationship).isRequired,
  },

  childContextTypes: {
    subscriber: React.PropTypes.instanceOf(Subscriber).isRequired,
  },

  mixins: [
    linkStateWithStores([GroupStore]),
  ],

  getInitialState() {
    const { relationship } = this.props;

    return Object.assign({
      relationship,
    }, this.getStateFromStores());
  },

  getChildContext() {
    const { relationship } = this.props;
    const subscriber = relationship.getRelatedUser();

    return {
      subscriber,
    };
  },

  componentDidMount() {
    this.fetchTeacherDetailIfAdmin();
    if (!GroupStore.isLoaded()) {
      GroupActions.loadGroups();
    }
  },

  componentWillReceiveProps(newProps) {
    this.setState(this.getSubscriptionStateFromStores(newProps.relationship));
  },

  getStateFromStores() {
    const { relationship } = this.props;

    return Object.assign(this.getSubscriptionStateFromStores(relationship), {
      groups: GroupStore.getOwnedGroups(),
    });
  },

  getSubscriptionStateFromStores(relationship) {
    const subscriber = relationship.getRelatedUser();

    return {
      subscriptionsToMe: relationship.getSubscriptionsToMe(),
      subscriptionsToUser: relationship.getSubscriptionsToUser(),
      subscriber,
      note: subscriber.getNote(),
    };
  },

  fetchTeacherDetailIfAdmin() {
    const orgsWhereUserAdmins = this.props.relationship.getAdminAtOrgIds();
    const currentIsAdmin = orgsWhereUserAdmins.length > 0;

    const relatedUser = this.props.relationship.getRelatedUser();
    const relatedIsTeacher = relatedUser.getRole() === Roles.teacher;

    if (currentIsAdmin && relatedIsTeacher && !this.state.teacherDetail) {
      // any org will work for
      const orgId = orgsWhereUserAdmins[0];

      const onSuccess = (teacherDetail) => this.setState({ teacherDetail });
      // FIXME @team Graph shouldn't this give user feedback?
      const onError = (err) => console.warn(err);

      TeacherDetail.getTeacherByOrgAndUserId(orgId, relatedUser.id)
        .then(onSuccess, onError);
    }
  },

  shouldRenderMediums() {
    // If this is a not a subscriber of one of my classes
    // then do not display devices.
    return this.props.relationship.getSubscriptionsToMe().length > 0;
  },

  renderDetails() {
    if (this.shouldRenderMediums()) {
      return (
        <div>
          <RelationshipViewMediums subscriber={this.state.subscriber} />
          <RelationshipViewNotes subscriber={this.state.subscriber} />
        </div>
      );
    } else {
      return <span>No details about this person.</span>;
    }
  },

  renderOwnGroups() {
    const { groupMember } = this.props;

    const { subscriptionsToMe } = this.state;
    if (subscriptionsToMe.isEmpty()) {
      return null;
    } else {
      return (
        <RelationshipViewGroupList
          legend="Classes joined"
          groupSubscriptions={wrapSubscriptions(subscriptionsToMe)}>
          <footer className="RelationshipView-groups-footer">
            {groupMember && !groupMember.isOwner() && (
              <CopySubscriberButton
                relationship={this.props.relationship}
                groups={this.state.groups}
              />
            )}
          </footer>
        </RelationshipViewGroupList>
      );
    }
  },

  renderTheirGroups() {
    const forAllGroups = () => {
      const allTheirGroups = this.state.teacherDetail.getGroups()
        .map(group => GroupStore.getGroup(group.id) || group)
        .filter(group => !group.isStaffClass());
      return wrapGroups(allTheirGroups, this.state.subscriptionsToUser);
    };

    const forSubscribedGroups = () => {
      // Filter out groups that are owned by the current user from subscribed groups
      const unowned = new Subscriptions(this.state.subscriptionsToUser.filter(subscription => {
        const group = GroupStore.getGroup(subscription.getGroupId());
        return !group.isOwnedByUser(CurrentUser.getUserId());
      }));

      return wrapSubscriptions(unowned);
    };

    const visibles = this.state.teacherDetail ? forAllGroups() : forSubscribedGroups();

    if (visibles.length) {
      return <RelationshipViewGroupList legend="Classes owned" groupSubscriptions={visibles} />;
    } else {
      return null;
    }
  },

  render() {
    const ProfileHeader = FeatureStore.hasFeature('web.new_relationship_view') ? RelationshipViewProfileHeader : RelationshipViewHeader;
    return (
      <section className={cx('RelationshipView', this.props.className)}>
        <ProfileHeader
          groupToAdmin={this.props.groupToAdmin}
          groupMember={this.props.groupMember}
          relationship={this.props.relationship}
          onRequestHide={this.props.onRequestHide}
          subscriber={this.state.subscriber}
          teacherDetail={this.state.teacherDetail}
        />
        <RelationshipViewUntrustedName subscriber={this.state.subscriber} />
        <BoxBody>
          {this.state.teacherDetail &&
            <TeacherDetailActivitySection teacherDetail={this.state.teacherDetail} />}
          <Fieldset legend="Details" size="small">
            {this.renderDetails()}
          </Fieldset>
          {this.renderOwnGroups()}
          {this.renderTheirGroups()}
        </BoxBody>
      </section>
    );
  },
});

export default RelationshipView;



// WEBPACK FOOTER //
// ./src/user/components/RelationshipView.jsx